import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { NavLink, useLocation } from 'react-router-dom'
import { Grid, List, ListItem, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import { menuTabList } from './menuTabList'
import { userEquitySelector } from '../../../store/selectors'

const useStyles = makeStyles((theme: Theme) => ({
  navWrap: {
    alignItems: 'center',
    justifyContent: 'center',
    width: 816,
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 0,
    paddingBottom: 0,
  },
  navItem: {
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    width: 202,
    maxWidth: 202,
    height: 72,
    marginRight: 2,
    flexGrow: 1,
    '&:last-child': {
      maxWidth: '100%',
      flexGrow: 3,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      justifyContent: 'center',
    },
  },
  active: {
    borderBottom: `2px solid ${theme.palette.secondary.main}`,
  },
  navLink: {
    textDecoration: 'none',
    color: theme.palette.primary.light,
    '&::before': {
      position: 'absolute',
      content: "''",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
  },
  navText: {
    color: theme.palette.primary.light,
    fontSize: 16,
  },
  sum: {
    fontSize: 14,
    color: theme.palette.secondary.light,
  },
}))

export const MenuDashboard: FC = () => {
  const classes = useStyles()
  const location = useLocation()
  const equity = useSelector(userEquitySelector)

  return (
    <>
      <Grid container className={classes.navWrap}>
        <List component="nav" aria-label="main mailbox folders" className={classes.nav}>
          {menuTabList
            .filter((nav) => !nav.inactive)
            .map((navItem, index) => (
              <ListItem
                className={clsx(classes.navItem, location.pathname.includes(navItem.path) ? classes.active : '')}
                key={index + navItem.name}
              >
                {navItem.name !== 'Portfolio' ? (
                  <NavLink to={navItem.path} className={classes.navLink}>
                    <Typography className={classes.navText}>{navItem.name}</Typography>
                  </NavLink>
                ) : (
                  <>
                    <Typography className={classes.navText}>Total portfolio value:</Typography>
                    <Typography className={classes.sum}>{equity}</Typography>
                  </>
                )}
              </ListItem>
            ))}
        </List>
        {/* <Grid container className={classes.navItem} /> */}
      </Grid>
    </>
  )
}
